import React from 'react';

import styled from 'styled-components';

import { useSnapshotEditorContext } from './SnapshotEditorContext';
import { useAppSelector } from '../../../store/hook';
import { getCommunityById } from '../../../utils/helpers/communityMap';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: 30px;
  padding-bottom: 0px;
`;

const Title = styled.div`
  font-family: var(--font-bold);
  color: var(--text-primary);
  font-size: 20px;
`;

const Community = styled.div`
  color: var(--text-secondary);
  font-size: 14px;
  span {
    color: var(--dark-blue);
  }
`;

const SnapshotEditorModalHeader = () => {
  const { communityMap } = useAppSelector((state) => state.global);
  const { communityId } = useSnapshotEditorContext();
  const community = getCommunityById(communityMap, communityId);
  const communityName = community?.comunity_name ?? 'Unknown Community';

  return (
    <Container>
      <Title>Add Historical Data</Title>
      <Community>
        for <span>{communityName}</span>
      </Community>
    </Container>
  );
};

export default SnapshotEditorModalHeader;
